import { sp, SPRest } from "@pnp/sp";
import { Web, IWeb } from "@pnp/sp/webs";
import { graph, GraphRest } from "@pnp/graph";
import { BearerTokenFetchClient } from "@pnp/nodejs";
import "@pnp/sp/lists";
import "@pnp/sp/items";
import "@pnp/sp/site-users/web";
import "@pnp/graph/users";
import "@pnp/graph/contacts";
import { Utilities, String, axios } from "../../utils/utilities";

import config from "../../config/config.json";

export interface IAuthMe {
  id_token: string;
  provieder_name: string;
  user_claims: IAuthClaims[];
  user_id: string;
}
export interface IAuthClaims {
  typ: string;
  val: string;
}

export interface IBaseService {
  context: any;
  webUrl: string;
  logo: string;
}
export interface IBearerToken {
  token_type: string;
  expires_in: string;
  not_before: string;
  expires_on: string;
  resource: string;
  access_token: string;
}

export default class BaseService {
  private _spContext: SPRest;
  private _spGraph: GraphRest;
  private _context: any;
  private _webUrl: string;
  protected web: IWeb;
  protected params: IBaseService;
  private _promArr: any[];

  constructor(params?: IBaseService) {
    this.params = params;
    if (!Utilities.isNullObject(params)) {
      this._webUrl = params.webUrl;
      this._context = params.context;
    }

    if (!Utilities.isNullObject(this._context)) {
      this.configProdEnvironment();
      this._spGraph = graph;
      this._spContext = sp;
      this.web = sp.web;

      if (!String.IsNullOrWhiteSpace(this._webUrl)) {
        this.web = Web(this._webUrl);
      }
    }
  }

  private configProdEnvironment(): void {
    sp.setup({
      spfxContext: this._context,
      sp: {
        headers: {
          Accept: "application/json;odata=verbose",
        },
      },
      defaultCachingStore: "session",
      defaultCachingTimeoutSeconds: 300,
    });
    graph.setup({
      spfxContext: this._context,
    });
  }

  public async getSPContext(): Promise<SPRest> {
    if (this._context || this._spContext) {
      return this._spContext;
    } else {
      if (this._promArr)
        await Promise.all(this._promArr);
      else
        this._promArr = [];

      let prom = this.promGes();
      this._promArr.push(prom);

      return prom;
    }
  }

  public async promGes(): Promise<SPRest> {
    return new Promise((resolve, reject) => {
      if (this._context || this._spContext) {
        return resolve(this._spContext);
      } else {
        axios.post<IBearerToken>(
          `${config.proxy}/api/sp`,
          config.sp.oauth2
        ).then((token) => {
          sp.setup({
            sp: {
              baseUrl: config.sp.siteUrl,
              fetchClientFactory: () => {
                return new BearerTokenFetchClient(token.data.access_token);
              },
            },
            defaultCachingStore: "session",
            defaultCachingTimeoutSeconds: 300,
          });
          this._spContext = sp
          return resolve(sp);
        })

      }
    });
  }

  public async getGraph(): Promise<GraphRest> {
    if (!Utilities.isNullObject(this._context)) {
      return this._spGraph;
    } else {
      const token = await axios.post<IBearerToken>(
        `${config.proxy}/api/graph`,
        config.graph.oauth2
      );
      graph.setup({
        graph: {
          fetchClientFactory: () => {
            return new BearerTokenFetchClient(token.data.access_token);
          },
        },
      });
      return graph;
    }
  }
  public async getAccessToken() {
    const token = await axios.post<IBearerToken>(
      `${config.proxy}/api/graph`,
      config.graph.oauth2
    );
    if (token) return token.data.access_token
  }

  public async getAdUserAuthMe() {
    const response = await axios.get<IAuthMe[]>(`${config.proxy}/.auth/me`);
    const authMe = response.data[0];
    return authMe;
  }
}
